module.exports = __webpack_public_path__ + "img/DayWorkStatus.0e02f1d2.svg";